<div class="modal-dialog-container">
  <!-- Modern Modal Header -->
  <div class="modal-header" fxLayout="row" fxLayoutAlign="space-between center">
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px">
      <div class="modal-icon-badge">
        <mat-icon>{{ pageType == 'add' ? 'create_new_folder' : 'folder' }}</mat-icon>
      </div>
      <div fxLayout="column">
        <h3 class="modal-title">{{ pageType == 'add' ? 'New ' : 'Edit' }} {{ itemType === eNavItemType.archives ? 'Archive' : 'Attestation' }} Folder</h3>
        <span class="modal-subtitle">Organize campaigns and audit reports into hierarchical folders</span>
      </div>
    </div>
    <button type="button" mat-icon-button mat-dialog-close class="modal-close-btn">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Modal Content Body -->
  <div mat-dialog-content class="modal-body">
    <form [formGroup]="folderForm" fxLayout="column" fxLayoutGap="16px">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Folder Name</mat-label>
        <input type="text" matInput placeholder="Enter folder name" formControlName="label"
          [(ngModel)]="archivedFolder.label" maxlength="25">
        <mat-icon matPrefix class="field-prefix-icon">folder_open</mat-icon>
        @if (archivedFolder?.label?.length == 25) {
          <mat-hint class="limit-hint">Folder name cannot exceed 25 characters.</mat-hint>
        }
        @if (submitted) {
          <mat-error>
            @for (message of folderForm.get('label')['errorMessages']; track message) {
              <span>{{ message }}</span>
            }
          </mat-error>
        }
      </mat-form-field>

      @if (pageType == 'add') {
        <div class="nested-checkbox-card" [class.checked]="archivedFolder.isChecked">
          <mat-checkbox class="example-margin" formControlName="isChecked" [(ngModel)]="archivedFolder.isChecked" color="primary">
            <span class="checkbox-label">Nest as subfolder under existing folder</span>
          </mat-checkbox>
        </div>
      }

      @if (archivedFolder.isChecked && pageType == 'add') {
        <div #parentFolderFieldWrap>
        <mat-form-field appearance="outline" class="w-100" aria-readonly>
          <mat-label>Select Parent Folder</mat-label>
          <input type="text" aria-label="Parent Folder" matInput (input)="filterChanged($event.target.value)"
            [matAutocomplete]="auto" formControlName="name" [(ngModel)]="archivedFolder.name" placeholder="Choose parent folder...">
          <mat-icon matPrefix class="field-prefix-icon">account_tree</mat-icon>
          <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [panelWidth]="parentFolderFieldWrap.offsetWidth" class="folder-tree-autocomplete">
            <mat-option disabled class="tree-header-option">Click a folder to select as parent:</mat-option>
            @if (nodeSelected) {
              <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="folder-tree">
                <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding [matTreeNodePaddingIndent]="12">
                  <div class="tree-node-row" (click)="selectParent(node.id, node.name)">
                    <mat-icon class="tree-node-icon">folder</mat-icon>
                    <span class="tree-node-name">{{ node.name }}</span>
                  </div>
                </mat-tree-node>
                <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding [matTreeNodePaddingIndent]="20">
                  <div class="tree-node-row" (click)="selectParent(node.id, node.name)">
                    <mat-icon class="tree-node-icon">folder_shared</mat-icon>
                    <span class="tree-node-name">{{ node.name }}</span>
                  </div>
                </mat-tree-node>
              </mat-tree>
            }
          </mat-autocomplete>
          @if (submitted) {
            <mat-error>
              @for (message of folderForm.get('name')['errorMessages']; track message) {
                <span>{{ message }}</span>
              }
            </mat-error>
          }
        </mat-form-field>
        </div>
      }
    </form>
  </div>

  <!-- Modal Action Buttons -->
  <div mat-dialog-actions class="modal-footer" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="12px">
    <button type="button" mat-stroked-button class="btn-cancel" (click)="onClick(false)">
      Cancel
    </button>
    <button type="submit" (click)="createFolder()" color="primary" mat-raised-button class="btn-submit">
      <mat-icon>check</mat-icon>
      {{ pageType == 'add' ? 'Create Folder' : 'Update Folder' }}
    </button>
  </div>
</div>